export enum overlayAssetConfig {
    //startButton = "assets/overlay/start_btn.json",
    //cancelButton = "assets/overlay/canceled_btn.json",
    //settingPanelFrameImage = "assets/overlay/setting_frame.png",
    popupbackground = "assets/maxwin_popup/dpop_up.png",
    popupbackgroundbtn = "assets/maxwin_popup/popup_ok.png",

}